
import React from 'react'
import { component_tool } from '../../../../tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool
import { WizTableForm } from '../../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["2"] } })

export default (showDuration) => {
    const columns = [
        {
            title: "经销商名称",
            name: "name",
            dataIndex: "name",
            tableItem: {},
            searchItem: {},
          },
          {
            title: "经销商代码",
            name: "code",
            dataIndex: "code",
            searchItem: {},
          },
          {
            title: "销售代码",
            name: "preSalesNumber",
            dataIndex: "preSalesNumber",
            tableItem: {},
          },
          {
            title: "售后代码",
            name: "afterSalesNumber",
            dataIndex: "afterSalesNumber",
            tableItem: {},
          },
          {
            title: "品牌",
            name: "orgName",
            dataIndex: "orgName",
            tableItem: {},
          },
          {
            title: "品牌",
            name: "orgList",
            searchItem: {
              diy: WizTableForm,
              //selectType: "radio",
              ...organizationConfig
            }
          },
          {
            title: "区域",
            name: "regionName",
            dataIndex: "regionName",
            tableItem: {},
          },
          {
            title: "开店状态",
            name: "state",
            dataIndex: "state",
            tableItem: {},
            searchItem: {
              type: 'select',
            },
            dict: [
              { code: 0, codeName: "已关店" },
              { code: 1, codeName: "已开店" },
              { code: 2, codeName: "建设中" }
            ]
          },
          {
            title: "经销商规模",
            name: "scale",
            dataIndex: "scale",
            tableItem: {},
            searchItem: {},
          }
          
        ];

    return columns
}
